const formatDate = (
	date: string,
	locale: string,
	monthFormat: Intl.DateTimeFormatOptions['month'] = 'short'
): string => {
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: monthFormat,
		day: 'numeric',
	}
	return new Date(date).toLocaleDateString(locale, options)
}

export default formatDate
